/* Stormsure SDS library — renders product cards from sds-manifest.json */
(function () {
  'use strict';

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function fmtBytes(b) {
    return b > 1048576 ? (b / 1048576).toFixed(1) + ' MB' : Math.max(1, Math.round(b / 1024)) + ' KB';
  }

  function fmtDate(iso) {
    var d = new Date(iso + 'T00:00:00');
    return isNaN(d) ? '' : d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  }

  function init(root) {
    var manifestUrl = root.dataset.manifestUrl;
    var grid = root.querySelector('[data-sds-grid]');
    var status = root.querySelector('[data-sds-status]');
    var search = root.querySelector('[data-sds-search]');
    var langSel = root.querySelector('[data-sds-lang]');
    var catSel = root.querySelector('[data-sds-cat]');
    var data, langs = {};

    // Language to preselect from the shopper's market/locale.
    function autoLang() {
      var country = (root.dataset.country || '').toUpperCase();
      var locale = (root.dataset.locale || 'en').toLowerCase().split('-')[0];
      if (country === 'GB') return 'en-GB';
      if (locale !== 'en' && langs[locale]) return locale;
      return country && country !== 'GB' && locale === 'en' ? 'en-EU' : 'en-GB';
    }

    function fail(msg) {
      status.textContent = msg;
      status.classList.add('sds-lib__status--error');
    }

    function docFor(p, code) {
      for (var i = 0; i < p.docs.length; i++) if (p.docs[i].lang === code) return p.docs[i];
      return null;
    }

    function url(doc) {
      return new URL(doc.path, new URL(manifestUrl, location.href)).href + (doc.sha ? '?v=' + doc.sha : '');
    }

    function label(code) {
      var l = langs[code];
      return l.native === l.name ? l.name : l.native + ' (' + l.name + ')';
    }

    function meta(doc) {
      var bits = ['PDF'];
      if (doc.pages) bits.push(doc.pages + ' pages');
      bits.push(fmtBytes(doc.bytes));
      if (doc.revised) bits.push('Revised ' + fmtDate(doc.revised));
      if (doc.version) bits.push('v' + doc.version);
      return bits.join(' · ');
    }

    function card(p, wanted) {
      var c = el('article', 'sds-lib__card');
      c.appendChild(el('p', 'sds-lib__cat', p.category));
      c.appendChild(el('h2', 'sds-lib__name', p.name));

      var fallbacks = wanted && langs[wanted] && langs[wanted].region === 'eu' ? ['en-EU', 'en-GB'] : ['en-GB', 'en-EU'];
      var pick = docFor(p, wanted) ? wanted : (docFor(p, fallbacks[0]) ? fallbacks[0] : (docFor(p, fallbacks[1]) ? fallbacks[1] : p.docs[0].lang));
      var note = el('p', 'sds-lib__note');
      note.hidden = true;
      var selId = 'sds-sel-' + p.slug;
      var lab = el('label', 'sds-lib__sr', 'Language for ' + p.name);
      lab.htmlFor = selId;
      var sel = el('select', 'sds-lib__input');
      sel.id = selId;
      p.docs.forEach(function (d) {
        var o = el('option', null, label(d.lang));
        o.value = d.lang;
        sel.appendChild(o);
      });
      sel.value = pick;

      var btn = el('a', 'sds-lib__btn');
      btn.target = '_blank';
      btn.rel = 'noopener';
      var info = el('p', 'sds-lib__meta');

      function paint() {
        var d = docFor(p, sel.value);
        btn.href = url(d);
        btn.textContent = 'Download SDS';
        btn.setAttribute('aria-label', 'Download ' + p.name + ' safety data sheet, ' + label(d.lang));
        btn.setAttribute('hreflang', d.lang.split('-')[0]);
        info.textContent = meta(d);
      }
      sel.addEventListener('change', paint);
      paint();

      if (wanted && pick !== wanted) {
        note.textContent = 'Not yet available in ' + langs[wanted].name + ' — showing ' + langs[pick].name + '.';
        note.hidden = false;
      }

      c.appendChild(lab);
      c.appendChild(sel);
      c.appendChild(note);
      c.appendChild(btn);
      c.appendChild(info);

      if (p.docs.length > 1) {
        var det = el('details', 'sds-lib__all');
        det.appendChild(el('summary', null, 'All ' + p.docs.length + ' languages'));
        var ul = el('ul', 'sds-lib__list');
        p.docs.forEach(function (d) {
          var li = el('li');
          var a = el('a', null, label(d.lang));
          a.href = url(d);
          a.target = '_blank';
          a.rel = 'noopener';
          a.lang = d.lang.split('-')[0];
          li.appendChild(a);
          ul.appendChild(li);
        });
        det.appendChild(ul);
        c.appendChild(det);
      }
      return c;
    }

    function render() {
      var q = search.value.trim().toLowerCase();
      var wanted = langSel.value === 'auto' ? autoLang() : (langSel.value === 'all' ? '' : langSel.value);
      var cat = catSel.value;
      var shown = data.products.filter(function (p) {
        if (cat && p.category !== cat) return false;
        if (q && (p.name + ' ' + p.category).toLowerCase().indexOf(q) === -1) return false;
        return true;
      });
      grid.textContent = '';
      shown.forEach(function (p) { grid.appendChild(card(p, wanted)); });
      status.classList.remove('sds-lib__status--error');
      status.textContent = shown.length
        ? shown.length + (shown.length === 1 ? ' product' : ' products')
        : 'No products match your search.';
    }

    fetch(manifestUrl, { credentials: 'omit' })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      })
      .then(function (m) {
        data = m;
        m.languages.forEach(function (l) { langs[l.code] = l; });
        // Best sellers first (manifest "order"), then alphabetical.
        data.products.sort(function (a, b) {
          return (a.order || 999) - (b.order || 999) || a.name.localeCompare(b.name);
        });

        var used = {};
        data.products.forEach(function (p) { p.docs.forEach(function (d) { used[d.lang] = 1; }); });
        [['auto', 'Automatic (my region)'], ['all', 'Any language']].forEach(function (o) {
          var opt = el('option', null, o[1]);
          opt.value = o[0];
          langSel.appendChild(opt);
        });
        m.languages.forEach(function (l) {
          if (!used[l.code]) return;
          var opt = el('option', null, label(l.code));
          opt.value = l.code;
          langSel.appendChild(opt);
        });

        var allCat = el('option', null, 'All categories');
        allCat.value = '';
        catSel.appendChild(allCat);
        var cats = {};
        data.products.forEach(function (p) { cats[p.category] = 1; });
        Object.keys(cats).sort().forEach(function (c) {
          var opt = el('option', null, c);
          opt.value = c;
          catSel.appendChild(opt);
        });

        search.addEventListener('input', render);
        langSel.addEventListener('change', render);
        catSel.addEventListener('change', render);
        render();
      })
      .catch(function () {
        fail('Sorry, we could not load the safety data sheets just now. Please try again shortly or contact us.');
      });
  }

  document.querySelectorAll('.sds-lib[data-manifest-url]').forEach(init);
})();
